import Vue from 'vue';
import Router from 'vue-router';
import { getToken } from '@/utils/auth';

Vue.use(Router);

const routes = [
    {
        path: '*',
        redirect: '/index'
    },
    {
        name: 'login',
        component: () => import('./view/user/login'),
        meta: {
            title: '登录'
        }
    },
    {
        name: 'index',
        component: () => import('./view/index'),
        meta: {
            title: '首页'
        }
    },
    {
        name: 'groupTourList',
        component: () => import('./view/groupTour/list'),
        meta: {
            title: '跟团游列表'
        }
    },
    {
        name: 'groupTourDetail',
        component: () => import('./view/groupTour/detail'),
        meta: {
            title: '跟团游详情'
        }
    },
    {
        name: 'privateTourList',
        component: () => import('./view/privateTour/list'),
        meta: {
            title: '私家团列表'
        }
    },
    {
        name: 'privateTourDetail',
        component: () => import('./view/privateTour/detail'),
        meta: {
            title: '私家团详情'
        }
    },
    {
        name: 'routeList',
        component: () => import('./view/route/list'),
        meta: {
            title: '线路列表'
        }
    },
    {
        name: 'routeDetail',
        component: () => import('./view/route/detail'),
        meta: {
            title: '线路详情'
        }
    }
];

routes.forEach(route => {
    route.path = route.path || '/' + (route.name || '');
});

const router = new Router({
    mode: "history",
    routes: routes
});

// 不需要登录的白名单
const whiteList = ['login', 'routeDetail'];

router.beforeEach((to, from, next) => {
    const title = to.meta && to.meta.title;
    if (title) {
        document.title = title;
    }
    const hasToken = getToken() && getToken() !== 'null' && getToken() !== 'undefined';
    if (whiteList.includes(to.name)) {
        // 白名单页面直接放行
        if (hasToken && to.name === 'login') {
            next({ path: '/index' });
        } else {
            next();
        }
    } else {
        // 需要登录的页面
        if (hasToken) {
            next();
        } else {
            next({ name: 'login', query: { redirect: to.fullPath } });
        }
    }
});

export {
    router
};
